export default __webpack_public_path__ + "static/media/Logo-spread-suite_HUB.b266d149.svg";